<template lang="html">
  <div id="loading-screen" class="dn items-center justify-center">
    <!-- Keeley logo -->
    <div class="container">
      <img src="/static/the_keeley-logo.png" />
      <br /><br /><br /><br />
      <div class="relative">
        <div class="loading-bar" :style="{'width': percent + '%'}"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'loading-screen',
  data() {
    return {
      percent: 0
    };
  },
  methods: {
    setLoadingPercent(percent) {
      this.percent = percent;
    }
  },
  created() {
    window.setLoadingPercent = this.setLoadingPercent;
  }
};
</script>

<style lang="scss">
#loading-screen {
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  bottom: 0;
  background-color: #bceffa;
  z-index: 1000;

  .container {
    width: 400px;
    max-width: 85%;

    img {
      max-width: 100%;
    }
  }

  .relative {
    padding: 0 5%;
  }

  .loading-bar {
    height: 3px;
    background-color: #f60f60;
    transition: width 2s ease-out;
  }

  @media screen and (min-width: $breakpoint-medium) {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LoadingScreen.vue